/**
 * «Оплата прошла · N ₽», carried across the one navigation that would otherwise destroy it.
 *
 * The hold succeeds and the wizard replaces itself with the tracking screen in the same frame, so
 * anything held in the wizard's own state is unmounted before it can be read. A module-level value
 * outlives that transition, which is precisely what both mobile clients do by hosting the toast
 * above the navigation stack rather than inside the order flow.
 *
 * One shot, and deliberately not persisted: this confirms an event that just happened. A toast
 * restored from storage after a reload would announce a payment that occurred at an unknown time.
 */
type Listener = (text: string | null) => void;

let current: string | null = null;
const listeners = new Set<Listener>();

export function showPaidToast(text: string): void {
  current = text;
  for (const listener of listeners) listener(current);
}

export function dismissPaidToast(): void {
  if (current === null) return;
  current = null;
  for (const listener of listeners) listener(current);
}

export function subscribeToPaidToast(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/**
 * The value at subscribe time.
 *
 * `useSyncExternalStore` calls this before it ever calls the listener, so a toast raised during
 * the same tick the host mounts is still shown rather than missed.
 */
export function readPaidToast(): string | null {
  return current;
}
